import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../core/services/api.service';
import { TimezoneService } from './timezone.service';

export interface MesSerialSyncRecord {
  id: number;
  serialNumber: string;
  templateName: string;
  sectionName: string;
  attributeName: string;
  attributeValue: string | null;
  createdAt: string;
  updatedAt: string | null;
  hasHistory: boolean;
}

export interface MesSerialByBlockScheduleResult {
  serialNumber: string;
  records: MesSerialSyncRecord[];
}

export interface MesSerialSyncHistoryRecord {
  historyId: number;
  currentId: number;
  oldValue: string | null;
  newValue: string | null;
  changedAt: string;
  changedBy: number | null;
  changedByName: string | null;
}

export interface UpdateAttributeValueRequest {
  serialNumber: string;
  templateName: string;
  sectionName: string;
  attributeName: string;
  newValue: string | null;
  clientTimestamp?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class MesDataService {

  constructor(
    private apiService: ApiService,
    private timezoneService: TimezoneService
  ) {}

  getByBlockScheduleId(blockScheduleId: number): Observable<MesSerialByBlockScheduleResult[]> {
    return this.apiService.get(`MesData/GetByBlockScheduleId/${blockScheduleId}`);
  }

  getHistory(currentId: number): Observable<MesSerialSyncHistoryRecord[]> {
    return this.apiService.get(`MesData/GetHistory/${currentId}`);
  }

  updateAttributeValue(request: UpdateAttributeValueRequest): Observable<void> {
    return this.apiService.put('MesData/UpdateAttributeValue', {
      ...request,
      clientTimestamp: request.clientTimestamp ?? this.timezoneService.buildClientTimestamp()
    });
  }
}
